<template>
  <zen-one  :title="'Welcome to '">
    <z-page class="white--bg mt3 sh2" :title="'Apa Khabar ' + $page.props.auth.user.name + '!'" icon="fal fa-user">
    <w-flex wrap basis-zero>
      <div  class="xs6 bd2 sh1 bdrs5 ma2">
        <vue3-chart-js :type="doughnutChart.type" :data="doughnutChart.data" :options="doughnutChart.options"></vue3-chart-js>
      </div>
      <div  class="xs6 bd2 sh1 bdrs5 ma2">
        <vue3-chart-js :type="doughnutChart.type" :data="doughnutChart.data" :options="doughnutChart.options"></vue3-chart-js>
      </div>
    </w-flex>
    <br>
    <z-dashboard-item class="sh1 mb3" :use-icon="false" image="" text="" width="" height="" header="" title="Mohon" subtitle="">
          <template #subtitle>
            <p class="mb1 mt1 text-bold">{{ "" }}</p>
          </template>
        </z-dashboard-item>

    <!-- <z-animate-number value="29"></z-animate-number>

    <w-flex class="grow justify-space-betweenx basis-zero">


    </w-flex> -->

  </z-page>
  </zen-one>
  
</template>

<script>


import Vue3ChartJs from '@j-t-mcc/vue3-chartjs'

export default {
components: {
  Vue3ChartJs
},
  setup () {
    const doughnutChart = {
      id: 'doughnut',
      type: 'bar',
      data: {
        labels: ['2020', '2021'],
        datasets: [
          {
            backgroundColor: [
              '#37479e',
              '#2f3d88',
              '#273371',
              '#1f285a'
            ],
            data: [64.74, 94.63]
          }
        ]
      },
      options: { plugins: { legend: { display: true }, } }

    }

    const beforeRenderLogic = (event) => {
      //...
      //if(a === b) {
      //  event.preventDefault()
      //}
    }

    return {
      doughnutChart,
      beforeRenderLogic
    }
  },
data() {
    return {
  form: {
    valid: null,
    submitted: false,
    sent: false,
    errorsCount: 0
  },
  validators: {
    required: value => !!value || 'This field is required',
    consent: value => !!value || 'You must agree'
  },
  crumbs: [
    { label: this.$page.props.app_name, route: '/sitemap' },
    { label: 'Home', route: '/' },
    { label: 'Welcome', route: '/w-breadcrumbs' }
  ],
  showCard: false,
}},
methods: {
  onSuccess () {
    setTimeout(() => (this.form.sent = true), 2000)
  },
  onValidate () {
    this.form.sent = false
    this.form.submitted = this.form.errorsCount === 0
  }
},
mounted() {
    
    
}
}

</script>

<style>


</style>
